import { useQuery } from 'react-query';
import AnalyticsReportsApi from 'api/analytics-reports';
import { ApiClientError } from 'api/client';
import { isUnauthorizedApiClientError } from 'api/client/isUnauthorizedApiClientError';
import { useToast } from 'app/hooks/useToast';
import { queryKey } from 'constants/queryKey';
import { useTranslation } from 'react-i18next';

const STALE_TIME_MS = 10 * 60 * 1000;

export function useReportTemplatesQuery() {
  const { t } = useTranslation();
  const toast = useToast();

  return useQuery(
    queryKey.analyticsReportsTemplates(),
    () => AnalyticsReportsApi.getTemplates(),
    {
      staleTime: STALE_TIME_MS,
      onError: (e: ApiClientError) => {
        if (isUnauthorizedApiClientError(e)) {
          return;
        }
        toast(
          e?.userMessage ??
            t('analyticsReports.createReport.templatesLoadError', {
              defaultValue: 'Could not load report templates.',
            }),
          'error',
        );
      },
    },
  );
}
